export enum TemplateStatus {
  preview = 'preview',
  published = 'published',
}

export enum ContentStatus {
  preview = 'preview',
  published = 'published',
}
